import likeTip from './likeTip'
export default {
    mixins: [
        likeTip
    ],
    methods: {
        changeFavourite() {
            this.toggleFavourite('楼盘详情页——关注')
        }
    }
}